import { ActivatedRoute } from '@angular/router';
import { VideoBoard } from '../../../_shared/models/videoBoard.model';
import { inject, Injectable } from '@angular/core';
import { filter, map, Observable, switchMap } from 'rxjs';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { HttpClient } from '@angular/common/http';
import { Match } from '../../../_shared/models/match.model';

@Injectable({
  providedIn: 'root'
})
export class VenueVideoBoardsService {
  private activatedRoute = inject(ActivatedRoute)
  private httpClient = inject(HttpClient)

  videoBoards$: Observable<VideoBoard[] | null> = this.activatedRoute.params.pipe(
    takeUntilDestroyed(),
    filter(params => !!params['_venueId']),
    switchMap(params => this.httpClient.post<any>('api_endpoint' + `/venue/${params['_venueId']}/video-board/get`, {})),
    map(res => res.data)
  )

  videoBoards = toSignal<VideoBoard[]>(this.videoBoards$);

  constructor() { }
}
